import { Layout } from 'antd';
import Sidebar from '../components/Sidebar/Sidebar';
import Navbar from '../components/Navbar/Navbar';
import { Outlet } from 'react-router-dom';
import "./Layout.scss";

const { Content} = Layout;

const DashboardLayout = () => {
    return (
        <Layout className='layout'>
            <Navbar />
            <Layout className='dashboard-layout'>
                <Sidebar />
                <Content className='dashboard-content'>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default DashboardLayout;
